<template>
    <div>
        <SimpleTable
            :flat="true"
            title="Devoluciones"
            subtitle="Listado de devoluciones registradas"
            :columns="columns"
            :data="tableData"
            :skeleton-rows="5"
            :empty-text="'No hay devoluciones'"
            :default-col-width="defaultColWidth"
        >
            <template #cell-metodo_pago="{ value }">
                {{ filters.formatear_metodo_pago(value) }}
            </template>
            <template #cell-importe="{ value }">
                {{ formatPrice(value) }}
            </template>
            <template #footer>
                <tr class="tw:bg-gray-50">
                    <td colspan="6" class="tw:px-6 tw:py-3 tw:font-semibold">TOTAL</td>
                    <td class="tw:px-6 tw:py-3 tw:font-semibold">{{ formatPrice(totalImporte) }}</td>
                </tr>
            </template>
        </SimpleTable>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue';
    import filters from '@/filters';

    const props = defineProps({
        devoluciones: { type: Array, default: () => [] },
        devolucionesDetalle: { type: Array, default: null },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    });

    const columns = [
        { key: 'tpv_order', label: 'Nº pedido' },
        { key: 'categoria', label: 'Categoría' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'apellidos', label: 'Apellidos', class: 'tw:w-44'},
        { key: 'metodo_pago', label: 'Método de pago', class: 'tw:w-40' },
        { key: 'fecha', label: 'Fecha' },
        { key: 'importe', label: 'Importe', class: 'tw:w-[100px]' }
    ];

    const tableData = computed(() => {
        if (props.devolucionesDetalle && props.devolucionesDetalle.length) return props.devolucionesDetalle;
        if (props.devoluciones && props.devoluciones.length) return props.devoluciones;
        return [];
    });

    const totalImporte = computed(() => {
        return tableData.value.reduce((sum, row) => {
            return sum + (Number(row.importe) || 0);
        }, 0);
    });

    const formatPrice = filters.formatear_precio;
</script>
